// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Home from './Screens/Home';
// import LoginScreen from './components/Login/LoginScreen';
// import LeadDashboard from './Screens/LeadsDashboard/LeadDashboard';
// import ApplicationsDashboard from './Screens/ApplicationsDashboard/ApplicationsDashboard';
// import TVRDashboard from './Screens/TVRDashboard/TVRDashboard';
// import TVRscreen from './Screens/TVRscreens/TVRscreen';
// import './App.css';
// import ProtectedRoutes from './routes/ProtectedRoutes';
// import { Slide, ToastContainer } from 'react-toastify';
// import TrancheDashboard from './Screens/TrancheDashboard/TrancheDashboard';

// function App() {
//   return (
//     <>
//       <ToastContainer
//           position="top-right"
//           autoClose={5000}
//           hideProgressBar={false}
//           newestOnTop={false}
//           closeOnClick={false}
//           pauseOnHover
//           theme="colored"
//           transition={Slide}
//       />
//       <Router>
//         <div className="App">
//           <Routes>
//             <Route path="/" element={<LoginScreen />} />
//             <Route path="/leads" element={<ProtectedRoutes><LeadDashboard /></ProtectedRoutes>} />
//             <Route path="/applications" element={<ProtectedRoutes><ApplicationsDashboard /></ProtectedRoutes>} />
//             {/* <Route path="/home/:applicationNumber" element={<ProtectedRoutes><Home /></ProtectedRoutes>} /> */}
//             {/* <Route path="/home/:applicationId" element={<ProtectedRoutes><Home /></ProtectedRoutes>} /> */}
//             <Route path="/applications/:applicationId" element={<ProtectedRoutes><Home /></ProtectedRoutes>} />
//             <Route path="/tvr" element={<TVRDashboard />} />
//           <Route path="/tvr-borrower-details/:applicationNumber" element={<TVRscreen />} />
//           <Route path="/tranche" element={<TrancheDashboard />} />
//         </Routes>
//         </div>
//       </Router>
//     </>
//   );
// }

// export default App;

import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';
import './App.css';
import ProtectedRoutes from './routes/ProtectedRoutes';
import SeedsLogo from '../src/assets/images/SeedsLogo.png';
import SproutLoader from './components/SproutLoader/SproutLoader';
import TrancheLoanDashboard from './Screens/TrancheDashboard/TrancheLoanDashboard/TrancheLoanDashboard';
import ActiveTrancheView from './Screens/TrancheDashboard/ActiveTrancheView/ActiveTrancheView';
import InsuranceDashboard from './Screens/InsuranceDashboard/InsuranceDashboard';
import Reports from './Screens/Reports/Reports';
import LeadReports from './Screens/Reports/LeadReports/LeadReports';
import ApplicationReports from './Screens/Reports/ApplicationReports/ApplicationReports';
import LimitSanctionReports from './Screens/Reports/LimitSanction/LimitSanction';
import TrancheReports from './Screens/Reports/TrancheReports/TrancheReports';
import ActiveTrancheDetails from './Screens/TrancheDashboard/ActiveTrancheView/ActiveTrancheDetails';
import Supplier from './Screens/Reports/Supplier/Supplier';
import ActiveCustomer from './Screens/Reports/ActiveCustomer/ActiveCustomer';
import RepaymentReports from './Screens/Reports/RepaymentReports/RepaymentReports';
import Demand from './Screens/Reports/Demand/Demand';
import UserManagementDashboard from './Screens/UserManagement/UserManagementDashboard';
import BranchOfficers from './Screens/UserManagement/BranchOfficers/BranchOfficers';
import ApplicationStagesDashboard from './Screens/ApplicationStagesDashboard/ApplicationStagesDashboard';
import StageAnalytics from './Screens/ApplicationStagesDashboard/StageData/StageData';
import UserDetailsPage from './Screens/UserManagement/UserDetailsPage/UserDetailsPage';

import Dashboard from './Screens/TaskManagementDashboard/Dashboard/Dashboard';
import PaymentTransactionReports from './Screens/Reports/PaymentTransactionReports/PaymentTransaction';
import BranchDashboard from './Screens/BranchDashboard/BranchDashboard';
import ReportsPage from './Screens/Reports/ReportViews/ReportsPage';
import AnalyticsDashboard from './Screens/Analytics/Dashboard/AnalyticsDashboard';
import RolesPermissionsDashboard from './Screens/UserManagement/RolesAndPermissions/RolesPermissionsDashboard/RolesPermissionsDashboard';
import RolesPermissionsLayout from './Screens/UserManagement/RolesAndPermissions/RolesPermissionsLayout/RolesPermissionsLayout';
import StageTransitionRulesLayout from './Screens/StageTransitionRules/StageTransitionRulesLayout/StageTransitionRulesLayout';
import { useDispatch, useSelector } from 'react-redux';
import { getOfficerProfile } from './redux/UserReducer/action';
import Unauthorized from './Screens/Unauthorized/Unauthorized';
import RedirectToHome from './Screens/RedirectToHome/RedirectToHome';
import RejectedApplicationsDashboard from './Screens/RejectedApplicationsDashboard/RejectedApplicationsDashboard';
import QueryManagementReport from './Screens/Reports/QueryManagementReport/QueryManagementReport';
import DeletedApplicationsDashboard from './Screens/DeletedApplicationsDashboard/DeletedApplicationsDashboard';
import TeamOverview from './Screens/TeamOverview/pages/TeamOverviewDashboard/TeamOverview';
import ErrorBoundaryWrapper from './components/ErrorBoundary/ErrorBoundaryWrapper';
import { useIdleLogout } from './hooks/useIdleLogout';
import { useSessionLivenessPoll } from './hooks/useSessionLivenessPoll';


// Lazy load components
const Home = lazy(() => import('./Screens/Home'));
const LoginScreen = lazy(() => import('./components/Login/LoginScreen'));
const LeadDashboard = lazy(() =>
  import('./Screens/LeadsDashboard/LeadDashboard')
);
const ApplicationsDashboard = lazy(() =>
  import('./Screens/ApplicationsDashboard/ApplicationsDashboard')
);
const TVRDashboard = lazy(() => import('./Screens/TVRDashboard/TVRDashboard'));
const TVRscreen = lazy(() => import('./Screens/TVRscreens/TVRscreen'));
const TrancheDashboard = lazy(() =>
  import('./Screens/TrancheDashboard/TrancheDashboard')
);

const FILTER_KEYS = [
  'tvrApplicationFilters',
  'paymentTransactionFilters',
  'rpsFilters',
  'leadFilters',
  'trancheFilters',
  'supplierFilters',
  'limitSanctionFilters',
  'queryManagementFilters',
  'demandFilters',
  'activeCustomerFilters',
  'applicationFilters',
  'rejectedApplicationFilters',
  'deletedApplicationFilters',
  'branchApplicationFilters',
  'applicationStageFilters',
];

const getBaseDashboard = (pathname) => {
  if (pathname.startsWith('/applications')) return 'applications';
  if (pathname.startsWith('/leads')) return 'leads';
  if (pathname.startsWith('/tvr')) return 'tvr';
  if (pathname.startsWith('/tranche-view') || pathname.startsWith('/loan-view')) return 'tranche';
  if (pathname.startsWith('/insurance')) return 'insurance';
  if (pathname.startsWith('/reports')) return 'reports';
  if (pathname.startsWith('/analytics')) return 'analytics';
  if (pathname.startsWith('/user-management')) return 'user-management';
  if (pathname.startsWith('/task-management')) return 'task-management';
  if (pathname.startsWith('/branch-dashboard')) return 'branch-dashboard';
  if (pathname.startsWith('/rejected-applications')) return 'rejected-applications';
  if (pathname.startsWith('/deleted-applications')) return 'deleted-applications';
  return 'other';
};

let lastBaseDashboard = null;

const FilterClearer = () => {
  const location = useLocation();
  const currentBase = getBaseDashboard(location.pathname);
  
  if (lastBaseDashboard && currentBase !== 'other' && lastBaseDashboard !== currentBase) {
    FILTER_KEYS.forEach(key => sessionStorage.removeItem(key));
  }
  
  if (currentBase !== 'other') {
    lastBaseDashboard = currentBase;
  }
  
  return null;
};

/**
 * App.jsx
 *
 * Fetch permissions once when the app loads (or when the officer logs in).
 * Every component downstream reads from store officer permissions —
 * no one reads sessionStorage for permissions anymore.
 * 
 * 
 */

/**
 * AppRouter
 * 
 * Every protected route now just declares `permission="SOME_CODE"`.
 * 
 * To give a new role access to /reports:
 *   → assign REPORTS_VIEW permission to that role on the backend
 *   → no frontend change needed
 */
function App() {
  // If sessionStorage is empty on browser restart but user chose "Keep me signed in", hydrate sessionStorage from localStorage
  if (!sessionStorage.getItem("tokens") && localStorage.getItem("tokens") && localStorage.getItem("remember_me") === "true") {
    try {
      sessionStorage.setItem("tokens", localStorage.getItem("tokens"));
      sessionStorage.setItem("officer", localStorage.getItem("officer"));
      sessionStorage.setItem("isAuthenticated", localStorage.getItem("isAuthenticated"));
      sessionStorage.setItem("remember_me", "true");
    } catch (e) {
      console.error("Session hydration error", e);
    }
  }

  const dispatch = useDispatch();
  const { officerProfile, officerProfileLoading } = useSelector((store) => {
    return {
      officerProfile: store.UserReducer.officerProfile,
      officerProfileLoading: store.UserReducer.officerProfileLoading,
    }
  });
 
  const tokens = JSON.parse(localStorage.getItem("tokens")) || JSON.parse(sessionStorage.getItem("tokens")) || {};

  useIdleLogout(!!tokens?.token);
  useSessionLivenessPoll(!!tokens?.token);

  useEffect(() => {
    if (!tokens?.token) return; // not logged in, skip

    // Always re-fetch on mount to get fresh permissions
    // (catches mid-session role changes)
    dispatch(getOfficerProfile);
  }, [dispatch, tokens?.token]);

  // Only block render if we HAVE a token but profile hasn't loaded yet
  // If no token → user is not logged in → let them through to the login page
  if (tokens?.token && (officerProfileLoading || !officerProfile)) {
    return <SproutLoader />;
  }

  // console.log({ officerProfile });

  return (
    <>
      <div style={{ position: "absolute", zIndex: "999999999" }}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          pauseOnHover
          theme="colored"
          transition={Slide}
        />
      </div>

      <Router>
        <FilterClearer />
        <div className="App">
          <Suspense
            fallback={<SproutLoader />}
          >
            <Routes>
              <Route path="/" element={<LoginScreen />} />
              <Route
                path="/leads"
                element={
                  <ProtectedRoutes
                    permission={"LEAD_VIEW"}
                  >
                     <ErrorBoundaryWrapper componentName="LeadDashboard">
                      <LeadDashboard />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/applications"
                element={
                  <ProtectedRoutes
                    permission={"APPLICATION_VIEW"}
                  >
                      <ErrorBoundaryWrapper componentName="ApplicationsDashboard">
                    <ApplicationsDashboard />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/applications/:applicationId"
                element={
                  <ProtectedRoutes
                    permission={"SINGLE_APPLICATION_VIEW"}
                  >
                     <ErrorBoundaryWrapper componentName="ApplicationDetails">
                      <Home />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/tvr"
                element={
                  <ProtectedRoutes
                    permission={"TVR_VIEW"}
                  >
                       <ErrorBoundaryWrapper componentName="TVRDashboard">
                      <TVRDashboard />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/tvr-borrower-details/:applicationNumber"
                element={
                  <ProtectedRoutes
                    permission={"TVR_VIEW"}
                  >
                      <ErrorBoundaryWrapper componentName="TVRscreen">
                      <TVRscreen />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              {/* <Route path="/tranche" element={<ProtectedRoutes allowedRoles={['ADMIN']}><TrancheDashboard /></ProtectedRoutes>} /> */}
              <Route
                path="/loan-view"
                element={
                  <ProtectedRoutes
                    permission={"TRANCHE_OPEN"}
                  >
                   <ErrorBoundaryWrapper componentName="TrancheLoanDashboard">
                      <TrancheLoanDashboard />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/tranche-view"
                element={
                  <ProtectedRoutes
                    permission={"TRANCHE_OPEN"}
                  >
                     <ErrorBoundaryWrapper componentName="TrancheDashboard">
                      <TrancheDashboard />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/tranche-view/:trancheStatus/:trancheId"
                element={
                  <ProtectedRoutes
                    permission={`TRANCHE_OPEN`}
                  >
                     <ErrorBoundaryWrapper componentName="ActiveTrancheView">
                      <ActiveTrancheView />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/tranche-view/:trancheStatus/:trancheId?tab=tranche-details"
                element={
                  <ProtectedRoutes
                    permission={"TRANCHE_OPEN"}
                  >
                     <ErrorBoundaryWrapper componentName="ActiveTrancheDetails">
                      <ActiveTrancheDetails />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/insurance"
                element={
                  <ProtectedRoutes
                    permission={"INSURANCE_VIEW"}
                  >
                       <ErrorBoundaryWrapper componentName="InsuranceDashboard">
                      <InsuranceDashboard />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/reports"
                element={
                  <ProtectedRoutes
                    permission={"REPORTS_VIEW"}
                  >
                     <ErrorBoundaryWrapper componentName="Reports">
                      <Reports />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/reports/leads"
                element={
                  <ProtectedRoutes
                    permission={"REPORTS_LEADS_VIEW"}
                  >
                     <ErrorBoundaryWrapper componentName="LeadReports">
                      <LeadReports />
                    </ErrorBoundaryWrapper>
                    {/* <ReportsPage reportName={"Lead"} /> */}
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/reports/applications"
                element={
                  <ProtectedRoutes
                    permission={"REPORTS_APPLICATION_VIEW"}
                  >
                      <ErrorBoundaryWrapper componentName="ApplicationReports">
                      <ApplicationReports />
                    </ErrorBoundaryWrapper>
                    {/* <ReportsPage reportName={"Application"} /> */}
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/reports/limit-sanction"
                element={
                  <ProtectedRoutes
                    permission={"REPORTS_LIMIT_SANCTION_VIEW"}
                  >
                    <ErrorBoundaryWrapper componentName="LimitSanctionReports">
                      <LimitSanctionReports />
                    </ErrorBoundaryWrapper>
                    {/* <ReportsPage reportName={"Limit Sanction"} /> */}
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/reports/tranche"
                element={
                  <ProtectedRoutes
                    permission={"REPORTS_TRANCHE_VIEW"}
                  >
                     <ErrorBoundaryWrapper componentName="TrancheReports">
                      <TrancheReports />
                    </ErrorBoundaryWrapper>
                    {/* <ReportsPage reportName={"Tranche"} /> */}
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/reports/supplier"
                element={
                  <ProtectedRoutes
                    permission={"REPORTS_SUPPLIER_VIEW"}
                  >
                      <ErrorBoundaryWrapper componentName="Supplier">
                      <Supplier />
                    </ErrorBoundaryWrapper>
                    {/* <ReportsPage reportName={"Supplier"} /> */}
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/reports/demand"
                element={
                  <ProtectedRoutes
                    permission={"REPORTS_DEMAND_VIEW"}
                  >
                      <ErrorBoundaryWrapper componentName="Demand">
                      <Demand />
                    </ErrorBoundaryWrapper>
                    {/* <ReportsPage reportName={"Demand"} /> */}
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/reports/active-customer"
                element={
                  <ProtectedRoutes
                    permission={"REPORTS_ACTIVE_CUSTOMER_VIEW"}
                  >
                        <ErrorBoundaryWrapper componentName="ActiveCustomer">
                      <ActiveCustomer />
                    </ErrorBoundaryWrapper>
                    {/* <ReportsPage reportName={"Active Customer"} /> */}
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/reports/repayment"
                element={
                  <ProtectedRoutes
                    permission={"REPORTS_REPAYMENT_VIEW"}
                  >
                     <ErrorBoundaryWrapper componentName="RepaymentReports">
                      <RepaymentReports />
                    </ErrorBoundaryWrapper>
                    {/* <ReportsPage reportName={"Repayment"} /> */}
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/reports/payment-transaction"
                element={
                  <ProtectedRoutes
                    permission={"REPORTS_PAYMENT_TRANSACTION_VIEW"}
                  >
                    <ErrorBoundaryWrapper componentName="PaymentTransactionReports">
                      <PaymentTransactionReports />
                    </ErrorBoundaryWrapper>
                    {/* <ReportsPage reportName={"Payment Transaction"} /> */}
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/reports/query-management"
                element={
                  <ProtectedRoutes
                    permission={"QMS_REPORT_VIEW"}
                  >
                     <ErrorBoundaryWrapper componentName="QueryManagementReport">
                      <QueryManagementReport />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/user-management"
                element={
                  <ProtectedRoutes
                    permission={"USER_MANAGEMENT_VIEW"}
                  >
                     <ErrorBoundaryWrapper componentName="UserManagementDashboard">
                      <UserManagementDashboard />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/user-management/branch-officers"
                element={
                  <ProtectedRoutes
                    permission={"USER_MANAGEMENT_VIEW"}
                  >
                       <ErrorBoundaryWrapper componentName="BranchOfficers">
                      <BranchOfficers />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/analytics"
                element={
                  <ProtectedRoutes
                    permission={"APPLICATION_STAGES_SUMMARY_VIEW"}
                  >
                     <ErrorBoundaryWrapper componentName="ApplicationStagesDashboard">
                    <ApplicationStagesDashboard />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/analytics/:stageName"
                element={
                  <ProtectedRoutes
                    permission={"APPLICATION_STAGES_SUMMARY_VIEW"}
                  >
                     <ErrorBoundaryWrapper componentName="StageAnalytics">
                    <StageAnalytics />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              {/* <Route
                path="/user-management/roles-permissions-dashboard"
                element={
                  <ProtectedRoutes allowedRoles={['ADMIN', 'SUPERADMIN']}>
                    <RolesPermissionsDashboard />
                  </ProtectedRoutes>
                }
              /> */}
              <Route
                path="/user-management/roles-permissions/*"
                element={
                  <ProtectedRoutes
                    permission={"USER_MANAGEMENT_VIEW"}
                  >
                      <ErrorBoundaryWrapper componentName="RolesPermissionsLayout">
                      <RolesPermissionsLayout />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              {/* Gated on USER_MANAGEMENT_VIEW as a placeholder — this is an
                  admin-configuration surface (matches the backend's own
                  allowRoles([admin, superadmin]) gate on these routes), but
                  there's no dedicated PermissionMaster row for it yet. Swap
                  in a real STAGE_TRANSITION_RULE_MANAGE permission code once
                  backend RBAC seed data adds one. */}
              <Route
                path="/stage-transition-rules/*"
                element={
                  <ProtectedRoutes
                    permission={"VIEW_STAGE_TRANSITION_RULES"}
                  >
                      <ErrorBoundaryWrapper componentName="StageTransitionRulesLayout">
                      <StageTransitionRulesLayout />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              {/* <Route
                path="/"
                element={<Navigate to="/user-management" replace />}
              /> */}

              <Route
                path="/analytics-dashboard"
                element={
                  <ProtectedRoutes
                    permission={"ANALYTICS_VIEW"}
                  >
                    
                    <ErrorBoundaryWrapper componentName="AnalyticsDashboard">
                      <AnalyticsDashboard />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />

              <Route
                path="/user-management"
                element={
                  <ProtectedRoutes
                    permission={"USER_MANAGEMENT_VIEW"}
                  >
                    <UserManagementDashboard />
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/user-management/details/:type"
                element={
                  <ProtectedRoutes
                    permission={"USER_MANAGEMENT_VIEW"}
                  >
                    <ErrorBoundaryWrapper componentName="UserDetailsPage">
                      <UserDetailsPage />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/task-management/*"
                element={
                  <ProtectedRoutes
                    // permission={"TASKS_VIEW"}
                    permission={"QMS_STAGE_VIEW"}
                  >
                   <ErrorBoundaryWrapper componentName="TaskManagementDashboard">
                      <Dashboard />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              {/* <Route
                path="/branch-dashboard"
                element={
                  <ProtectedRoutes
                    // permission={"APPLICATION_VIEW"}
                    permission={"BRANCH_DASHBOARD_VIEW"}
                  >
                    <BranchDashboard />
                  </ProtectedRoutes>
                }
              /> */}
              <Route
                path="/rejected-applications"
                element={
                  <ProtectedRoutes
                    permission={"VIEW_REJECTED_APPLICATIONS"}
                  >
                      <ErrorBoundaryWrapper componentName="RejectedApplicationsDashboard">
                      <RejectedApplicationsDashboard />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/deleted-applications"
                element={
                  <ProtectedRoutes
                    permission={"VIEW_DELETED_APPLICATIONS"}
                  >
                     <ErrorBoundaryWrapper componentName="DeletedApplicationsDashboard">
                      <DeletedApplicationsDashboard />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              <Route
                // path="/team-overview"
                path="/team-overview"
                element={
                  <ProtectedRoutes
                    permission={"VIEW_TEAM_OVERVIEW"}
                  >
                      <ErrorBoundaryWrapper componentName="TeamOverview">
                      <TeamOverview />
                    </ErrorBoundaryWrapper>
                  </ProtectedRoutes>
                }
              />
              {/* At the bottom of your */}
              <Route
                path="/unauthorized"
                element={<Unauthorized />}
              />

              {/* Catch-all — unknown routes redirect to default landing page */}
              <Route
                path="*"
                element={<RedirectToHome />}
              />
            </Routes>
          </Suspense>
        </div>
      </Router>
    </>
  );
}

export default App;
